import { render, staticRenderFns } from "./AccrualsEstimationRulesList.vue?vue&type=template&id=f8613092&scoped=true"
import script from "./AccrualsEstimationRulesList.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimationRulesList.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimationRulesList.vue?vue&type=style&index=0&id=f8613092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8613092",
  null
  
)

export default component.exports